import axiosInstance from './axiosConfig';


// fulfillmentChannel record getting here
export const fulfillmentChannel = async ({ formattedEnd , formattedStart, selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');

  const response = await axiosInstance.get(`/geographical_sales/fulfillment_channel?start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};

// regionalShare record getting here
export const regionalShare = async ({ formattedEnd , formattedStart, selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');

  const response = await axiosInstance.get(`/geographical_sales/regional_share?start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};

// eliteWarehouserecord getting here
export const eliteWarehouse = async ({ formattedEnd , formattedStart, selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  
  const response = await axiosInstance.get(`/geographical_sales/elite_warehouse?start_date=${formattedStart}&end_date=${formattedEnd}&product_ids=${productIdsStr}&category_ids=${categoryIdsStr}`);
  return response.data;
};


// eliteWarehouserecord getting here
export const geographicalSales = async ({ formattedEnd , formattedStart, selectedIds }) => {
  const { productId = [], categoryId = [] } = selectedIds;
  const productIdsStr = productId.join(',');
  const categoryIdsStr = categoryId.join(',');
  const response = await axiosInstance.get(`/geographical_sales?start_date=${formattedStart}&end_date=${formattedEnd}&category_ids=${categoryIdsStr}`);
  return response.data;
};
